import React from "react";
import AIModuleSubtopic from "../AIModuleSubtopic";

const AdversarialSearchMinimax = () => (
  <AIModuleSubtopic
    title="Adversarial Search: Game Trees and Minimax Evaluation"
    videos={[
      "https://www.youtube.com/embed/tDv7lrklaQE"
    ]}
    takeaways={[
      { text: "Understand how to construct and traverse game trees using minimax evaluation." },
      { text: "Learn the impact and mechanics of alpha-beta pruning in reducing search space." }
    ]}
    questions={[
      {
        text: "Consider the game tree in which the static scores are from the first player’s point of view. Suppose the first player is a maximizing player. Applying minimax search, show the backed-up values in the tree. What move will the MAX choose? If the nodes are expanded from left to right, what nodes would not be visited using alpha-beta pruning? Also, explain the limitations of the Mini-Max search. How to overcome them?",
        image:"/ai_23.png"
      },
      
      {
        text: "Perform the minimax algorithm on the figure below",
        image:"/ai_24.png"
      },
      {
        text: "Consider the game tree given below. By Applying a mini-max search, show the backed-up values in the tree. If the nodes are expanded from left to right, what nodes would not be visited using alpha-beta pruning?",
        image:"/ai_25.png"
      }
    ]}
    exampleVideos={[]}
  />
);

export default AdversarialSearchMinimax;
